// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-result-certificate {\n  padding-top: 100px;\n  min-height: calc(100vh - 100px); }\n", "",{"version":3,"sources":["webpack://src/components/CheckoutAction/CheckoutResult/CertificateDownload/CertificateDownload.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,+BAA+B,EAAA","sourcesContent":[".checkout-result-certificate {\n  padding-top: 100px;\n  min-height: calc(100vh - 100px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
